import { render, staticRenderFns } from "./promocodes.vue?vue&type=template&id=45d5317c"
import script from "./promocodes.vue?vue&type=script&lang=js"
export * from "./promocodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports